<template>
  <div class="saddle-selection">
    <div class="saddle-selection__filters">
      <SaddleFilters />
    </div>
    <div class="saddle-selection__content">
      <h1>{{ t('setup.saddle.selection') }}</h1>

      <SaddleSelection @select="select" />

      <div class="saddle-selection__buttons">
        <BfButton
          :type="ButtonType.Outlined"
          @click="cancel"
        >
          {{ t('common.cancel') }}
        </BfButton>
        <BfButton
          :state="selected ? ButtonState.Enabled : ButtonState.Disabled"
          @click="install"
        >
          {{ t('common.install') }}
        </BfButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { ButtonState, ButtonType, BfButton } from '@finetic/bikefitting-ui'
import { useRouter } from 'vue-router'
import { useSaddleStore } from '@/store/saddleStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useI18n } from 'vue-i18n'
import SaddleFilters from '@/components/setup/saddle/SaddleFilters.vue'
import SaddleSelection from '@/components/setup/saddle/SaddleSelection.vue'

const { t } = useI18n()
const router = useRouter()
const saddleStore = useSaddleStore()
const measurementStore = useMeasurementStore()
const selected = ref()

saddleStore.reset()

const select = (saddle: any) => {
  selected.value = saddle
}

const cancel = () => {
  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}

const install = () => {
  if (measurementStore.selectedMeasurement) {
    measurementStore.selectedMeasurement.saddle.active = selected.value
  }

  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}
</script>

<style lang="scss">
.saddle-selection {
  display: grid;
  grid-template-columns: 40% 60%;
  height: 100%;

  &__filters {
    background-color: #f5f5f5;
  }

  &__content {
    background-color: #fbfbfb;
    padding: 2.4rem;
  }

  &__buttons {
    margin-top: 3.2rem;
    display: flex;
    justify-content: flex-end;
    gap: 0.8rem;
  }
}
</style>
